import { Store } from 'bernie-plugin-mobx';
import { ClientFactories } from 'bernie-plugin-mobx';
import { ClientLogger } from 'bernie-client';
import { VirtualAgentControlStore } from './virtual-agent-control-store';

export const stores: ClientFactories = {
  virtualAgentControlStore: (): Store =>
    new VirtualAgentControlStore({}, ClientLogger.getLoggerWithIdentifier('pwa.store.virtualagentcontrol')),
};
